import { useState, useRef } from "react";
import apiService from "services/api";
import { useQuery } from "react-query";
import { FormGroup, Label, Input, Button } from "reactstrap";
import Select from "react-select";
import { FormEntry, ImageUpload } from "components";
import { useHistory } from "react-router-dom";
import { useNotificationContext } from "contexts";
import useProgressBar from "components/ProgressBar/useProgressBar";
import { encodeImageFileAsURL } from "utils/fileToBase64";
import { initialAddPointsRecordState } from "./constants";
import { useForm, Controller } from "react-hook-form";
import { paymentOptions } from "constants";

const AddPointsPage = () => {
	const { createNotification } = useNotificationContext();
	const history = useHistory();
	const [ProgressBar, startProgress, finishProgress] = useProgressBar();

	const { data: parents, isLoading } = useQuery("parent", () => apiService.parent.get(), {
		refetchOnwindowFocus: false,
		onSuccess: (data) => setSelectedParentId(data.length ? data[0].id : undefined),
	});

	const {
		register,
		handleSubmit,
		control,
		formState: { errors },
	} = useForm({ defaultValues: initialAddPointsRecordState });

	const fileInputRef = useRef();
	const [showLoading, setShowLoading] = useState(false);

	const [selectedParentId, setSelectedParentId] = useState(parents ? parents[0] : undefined);

	const startSubmit = () => {
		setShowLoading(true);
	};

	const endSubmit = () => {
		setShowLoading(false);
		finishProgress();
	};

	const submitAddPoint = async (data) => {
		startSubmit();

		var invoiceImg;
		if (fileInputRef.current?.files?.length) {
			startProgress();
			invoiceImg = await encodeImageFileAsURL(fileInputRef.current.files[0]);
		}

		const { membershipPoints, paymentMethod } = data;

		try {
			await apiService.points.add(selectedParentId, {
				invoiceImg,
				membershipPoints,
				paymentMethod,
			});
			createNotification({
				type: "success",
				message: "Successfully added points",
			});
			history.push("/coffee/add-points");
		} catch (error) {
			createNotification({
				type: "danger",
				message: error.message,
			});
		} finally {
			endSubmit();
		}
	};
	return (
		<form className="content" onSubmit={handleSubmit(submitAddPoint)}>
			<h4 className="mb-4 text-center">Add Points</h4>
			<FormGroup className="mb-4">
				<Label for="exampleSelect1" className="text-white">
					Member
				</Label>
				<Select
					className="react-select primary"
					classNamePrefix="react-select"
					// value={selectedParentId}
					onChange={(option) => setSelectedParentId(option.value)}
					disabled={isLoading}
					options={
						!isLoading
							? parents.map((parent) => ({
									value: parent.id,
									label: parent.firstName + " " + parent.lastName,
							  }))
							: []
					}
					placeholder="Search by member"
					required
				/>
			</FormGroup>

			<FormEntry formLabel="Points To Add" type="number" register={register} required={true} name="membershipPoints" error={errors.membershipPoints} />

			<div className="mb-3 mt-1">
				<Controller
					rules={{
						required: {
							value: true,
							message: "Payment method is required",
						},
					}}
					control={control}
					name="paymentMethod"
					render={({ field: { ref, value, onChange } }) => (
						<Select
							inputRef={ref}
							className="react-select info"
							classNamePrefix="react-select"
							value={paymentOptions?.find((method) => value === method.value)}
							onChange={(val) => onChange(val.value)}
							options={paymentOptions || []}
							placeholder="Select payment method...."
						/>
					)}
				/>
				{errors.paymentMethod && (
					<div className="text-center">
						<small className="text-danger">{errors.paymentMethod?.message}</small>
					</div>
				)}
			</div>

			<FormGroup>
				<Label for="exampleEmail" className="text-white">
					Receipt
				</Label>
			</FormGroup>
			<ImageUpload hasButton={false} fileInputRef={fileInputRef} />
			{showLoading && <ProgressBar />}

			<div className="text-right">
				{showLoading ? (
					<Button color="primary" disabled={true}>
						<span className="spinner-border"></span>
					</Button>
				) : (
					<Button color="primary" type="submit">
						Confirm
					</Button>
				)}
			</div>
		</form>
	);
};

export default AddPointsPage;
